import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
// import { Paper } from "@mui/material";
import { API_DOMAIN_URL } from "../Common";

export function GroupEditMode({ group, setDisplayMode, updateOwnedGroups }) {
  // Validationスキーマの定義
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("グループ名を入力してください").max(100, "グループ名は100文字以内で入力してください"),
    Note: Yup.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if (data == undefined || data.Name == undefined) {
      console.log("Invalid Input Value");
      return;
    }

    let edittingGroup = {};
    Object.assign(edittingGroup, group);
    edittingGroup.Name = data.Name;
    edittingGroup.Note = data.Note;

    updateGroup(edittingGroup);
  };

  const updateGroup = (edittingGroup) => {
    if (!edittingGroup) {
      return;
    }

    // update db
    const bodyString = JSON.stringify(edittingGroup);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/UpdateGroup?code=${code}&GroupId=${edittingGroup.id}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          updateSuccessModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          updateErrorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const deleteGroup = () => {
    if (!group || !group.id) {
      return;
    }

    // delete from db
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/DeleteGroup?code=${code}&GroupId=${group.id}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: "",
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          deleteSuccessModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          deleteErrorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 更新完了確認のモーダル
  const [updateSuccessModalStatus, setUpdateSuccessModalStatus] =
    React.useState(false);
  const updateSuccessModalOpen = () => {
    setUpdateSuccessModalStatus(true);
  };
  const updateSuccessModalClose = () => {
    setUpdateSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedGroups(); // 組織内ユーザーを再取得
  };

  // エラーモーダル
  const [updateErrorModalStatus, setUpdateErrorModalStatus] =
    React.useState(false);
  const updateErrorModalOpen = () => {
    setUpdateErrorModalStatus(true);
  };
  const updateErrorModalClose = () => {
    setUpdateErrorModalStatus(false);
  };

  // 削除確認モーダル
  const [deleteConfirmModalStatus, setDeleteConfirmModalStatus] =
    React.useState(false);
  const deleteConfirmModalOpen = () => setDeleteConfirmModalStatus(true);
  const deleteConfirmModalClose = () => setDeleteConfirmModalStatus(false);
  const onDeleteConfirmed = () => {
    setDeleteConfirmModalStatus(false);
    deleteGroup();
  };

  // 削除完了確認のモーダル
  const [deleteSuccessModalStatus, setDeleteSuccessModalStatus] =
    React.useState(false);
  const deleteSuccessModalOpen = () => {
    setDeleteSuccessModalStatus(true);
  };
  const deleteSuccessModalClose = () => {
    setDeleteSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedGroups(); // 組織内ユーザーを再取得
  };

  // 削除エラーモーダル
  const [deleteErrorModalStatus, setDeleteErrorModalStatus] =
    React.useState(false);
  const deleteErrorModalOpen = () => {
    setDeleteErrorModalStatus(true);
  };
  const deleteErrorModalClose = () => {
    setDeleteErrorModalStatus(false);
  };

  //console.log(group);
  return (
    <>
      <Typography component="h1" variant="h5" sx={{ mt: 3 }}>
        グループ編集
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 5, p: 3, border: "1px solid grey" }}
      >
        <Typography variant="h6" align="center">
          グループ情報
        </Typography>
        <Grid md={{ flexGrow: 1 }} container spacing="2">
          <Grid item md={12}>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item md={12}>
                <TextField
                  name="Name"
                  fullWidth
                  required
                  size="small"
                  id="Name"
                  label="グループ名"
                  defaultValue={group.Name}
                  {...register("Name")}
                  error={errors.Name ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Name?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              sx={{ mt: "1px" }}
              spacing={1}
            >
              <Grid item md={12}>
                <TextField
                  name="Note"
                  required
                  fullWidth
                  size="small"
                  id="Note"
                  label="備考"
                  defaultValue={group.Note}
                  {...register("Note")}
                  error={errors.Note ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Note?.message}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={8} container justifyContent="right">
          <Button
            variant="contained"
            color="success"
            sx={{ mt: 2, width: 100 }}
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            更新
          </Button>
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          <Button
            variant="contained"
            color="error"
            sx={{ mt: 2, width: 100 }}
            onClick={() => deleteConfirmModalOpen()}
          >
            削除
          </Button>
        </Grid>
      </Grid>
      <Modal
        title={"グループ削除"}
        message={`「${group.Name}」を削除しますか？この操作は元に戻せません。`}
        status={deleteConfirmModalStatus}
        okBtnLabel={"削除"}
        okBtnCallback={onDeleteConfirmed}
        cancelBtnCallback={deleteConfirmModalClose}
      />
      <Modal
        title={"更新失敗"}
        message={"グループの更新に失敗しました"}
        status={updateErrorModalStatus}
        okBtnCallback={updateErrorModalClose}
      />
      <Modal
        title={"更新成功"}
        message={"グループの更新が完了しました"}
        status={updateSuccessModalStatus}
        okBtnCallback={updateSuccessModalClose}
      />
      <Modal
        title={"削除失敗"}
        message={"グループの削除に失敗しました"}
        status={deleteErrorModalStatus}
        okBtnCallback={deleteErrorModalClose}
      />
      <Modal
        title={"削除成功"}
        message={"グループの削除が完了しました"}
        status={deleteSuccessModalStatus}
        okBtnCallback={deleteSuccessModalClose}
      />
    </>
  );
}

GroupEditMode.propTypes = {
  group: PropTypes.object,
  setDisplayMode: PropTypes.any,
  updateOwnedGroups: PropTypes.any,
};
